import { Slide, toast } from "react-toastify";

export type SeedType = {
    id: string;
    author: string;
    avatar?: string;
    date: string;
    title: string;
    description: string;
    suggestion?: string;
    link?: string;
    file_name?: string;
    brief_summary?: string;
    elaborate_summary?: string;
    private?: boolean;
    draft?: boolean;
    finalized_date?: string;
    user_id?: string;
    mediaType?: string;
    citation?:string;
    podcast_summary?:string;
    status_info?:{
        logs:any;
        status?:string;
    };
    book_name?:string;
    chapter?:string;
    onCitationClick?: (citation: any) => void;

};
export interface DraftItemProps {
    draft: SeedType;
}
type PodcastType = {
    filename: string;
    date: string;
    link: string;
    media_type: string;
    podcast_summary?: string;
    text?: string;
    title?: string;
    citation?:string;
}
export interface PodcastItemProps {
    podcastObj: SeedType;
}
export type OptionRefactorPayload = {
    caselet: Caselet;
    index: number;
};
export type Caselet = {
    id: string;
    title: string;
    createdTime: string;
    authorName: string;
    summary: SummaryTab;
    view: number;
    challenges: DecisionPointTab[];
    published: boolean;
    // relivenceMatrix?: RelivenceMatrixTab;
};

export type SummaryTab = {
    background: string;
    scenario: string;
    outcome: string;
    possibleCurrentStates: string[];
    desiredTransformationGoal: string[];
};

export type DecisionPointTab = {
    title: string;
    challenge: string;
    options: string[];
    videos: string[];
};

export type RelivenceMatrixTab = {};

export type HtmlParsedAnswer = {
    answerHtml: string;
    citations: string[];
};

export type QdrantObject = {
    id: string;
    text: string;
    author: string;
    description: string;
    citation: string;
};

export interface EngagementType {
    SNo: string;
    blog_name: string;
    author: string;
    view_count: number;
}

export type ParticipantsType = {
    participant_name: string;
    participant_email: string;
    participant_organization: string;
    participant_link?: string;
    role?: string;
    SNo?: string;
    // Name: string;
    // Email: string;
    // Organization: string;
    // Link: string;
    // Role:string;
};
export type UsersType = {
    participant_name: string;
    participant_email: string;
    provider: string;
    created_at: string;
    logged_time: string;

};

export type LikeDislikeType = {
    timestamp: string;
};
export function giveErrorMessage(statusCode: number | undefined) {
    switch (statusCode) {
        case 404:
            return <div className="flex  justify-center h-44 w-full font-bold p-6">Resource not found. Please check the URL and try again.</div>;
        case 500:
            return <div className="flex  justify-center h-44 w-full font-bold p-6">Internal server error. Please try again later.</div>;
        case 400:
            return <div className="flex  justify-center h-44 w-full font-bold p-6">Bad request. Please check your request and try again.</div>;
        default:
            return <div className="flex  justify-center h-44 w-full font-bold p-6">Oops, something went wrong! </div>;
    }
}

export const truncateWords = (str: string, maxWords: number) => {
    const words = str.split(" ");
    if (words.length <= maxWords) {
        return str;
    }
    return words.slice(0, maxWords).join(" ") + " ...";
};

export function errorToast(errorMessage: string) {
    toast.error(errorMessage, {
        toastId: 1003,
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        transition: Slide,
        theme: "colored",
        style: { backgroundColor: "rgb(21 128 61))", marginTop: "8vh" }
    });
}
export function successToast(successMessage: string) {
    toast.success(successMessage, {
        toastId: 1001,
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        transition: Slide,
        theme: "colored",
        style: { backgroundColor: "rgb(67, 104, 80)", marginTop: "8vh" }
    });
}

export function isValidEpochTime(value: any): boolean {
    // Convert the value to a number if it's a string
    // console.log("value: ", value)
    if (typeof value === "string" && /^\d+$/.test(value)) {
        value = parseInt(value, 10);
    }
    // Check if the value is a number
    if (typeof value !== "number") {
        return false;
    }

    // Check if the value is within the valid UNIX timestamp range
    if (value < -8.64e12 || value > 8.64e12) {
        return false;
    }

    // Create a Date object and check if it's valid
    const date = new Date(value * 1000);
    return !isNaN(date.getTime());
}

export function get_user_data() {
    let userData: any = localStorage.getItem("user_data");
    //   console.log("userData: ", userData)
    if (userData) {
        try {
            userData = JSON.parse(userData);
            return userData;
            // console.log("userData: ", userData);
        } catch (e) {
            console.error("Error parsing mentee_data from localStorage:", e);
            userData = null; // or set a default object if needed
        }
    } else {
        userData = null;
    }
}
export interface ConfirmOptions {
    title?: string;
    subtitle?: string;
    confirmText?: string;
    cancelText?: string;
    onConfirm?: () => void;
    onCancel?: () => void;
    type?: "success" | "error" | "warning" | "info";
}

export type Nullable<T> = T | null;

export interface ConfirmContext {
    show: (options: Nullable<ConfirmOptions>) => void;
}
export function delete_user_data_from_client_side() {
    document.cookie = `access_token_cookie=''; path=/; SameSite=None; Secure`;
    localStorage.removeItem("user_data");
}

type MediaSourceKey = "blogs_and_chows" | "writeups_exclusive_content" | "sps_podcast" | "fullstack_leadership_podcast" | "books";

type SourceConfig = {
    weightage: number;
    percentage: number;
};
export type SourceWeightsType = {
    max_prefetch_documents: number;
    sources: Record<MediaSourceKey, SourceConfig>;
};

export const getInitials = (name: string | undefined) => {
    return name
        ?.split(" ")
        .map(n => n[0])
        .join("");
};

export function formatCustomTimestamp(timestamp: string): string {
    const isoString = timestamp.replace(" ", "T");
    const inputDate = new Date(isoString);

    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const monthIndex = inputDate.getMonth();
    const day = inputDate.getDate();
    const year = inputDate.getFullYear();

    return `${months[monthIndex]} ${day}, ${year}`;
}
